import { PayloadAction } from '@reduxjs/toolkit';
import { SingleItemPayload } from './types';
import { SingleItemData } from '../../items/slice/types';
import { initialState } from './index';

export const reducers = {
  getSingleItem(state, action: PayloadAction<SingleItemPayload>) {
    state.isLoading = true;
  },
  getSingleItemSuccess(state, action: PayloadAction<SingleItemData>) {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },
  getSingleItemFail(state, action: PayloadAction<unknown>) {
    state.isLoading = false;
    state.data = initialState.data;
    state.error = action.payload;
  },
  removeSingleItem(state) {
    state.isLoading = false;
    state.error = null;
    state.data = initialState.data;
  },
};
